import { call, put, takeLatest } from 'redux-saga/effects';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import {
  PACKS_REQUEST, packsSuccess, packsFailure,
} from '../../actions/billing/topup';

function* fetchPacks() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/topup-packs`,
      { headers: getLocalUser() },
    );
    const packs = (response.data?.data ?? response.data)?.packs || [];
    yield put(packsSuccess(packs));
  } catch (error) {
    yield put(Error(error));
    yield put(packsFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(PACKS_REQUEST, fetchPacks);
}
